import script from "./Organizations.vue?vue&type=script&setup=true&lang=js"
export * from "./Organizations.vue?vue&type=script&setup=true&lang=js"

import "./Organizations.vue?vue&type=style&index=0&id=e9c19600&lang=css"

const __exports__ = script;

export default __exports__